module.exports = __webpack_public_path__ + "img/b3.60c66365.png";